<template>
    <div id="app">
        <router-view class="app-content" />
    </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* height: 100%; */
  box-sizing: border-box;
  background: #e9e9e9;
  padding-bottom: 20px;
}
#app *,
#app *::after {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.app-content {
  width: 1190px;
  min-width: 1190px;
  margin: auto;
}
</style>
